import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Markup } from 'interweave';
import InfiniteScroll from "react-infinite-scroller";
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import axios from "axios";
import '../Dashboard.css';
import classes from "./ManagePlaylist.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";
import Spinner from "../../Global/Spinner";
import EmptyContent from "../../Global/EmptyContent";

import noThumb from "../../../images/no-thumb.jpg";

function ManagePlaylist() {
    const { id } = useParams();
    const [videos, setVideos] = useState(true);
    const [hasMore, sethasMore] = useState(true);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(false);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get('logged_user');

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/playlist.php`, {
                user_id: logged_user,
                play_id: id,
                action: 'GET_ALBUM_VIDEOS'
            }, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(res => {
                setVideos(res.data);
                res.data.length < 10 ? sethasMore(false) : sethasMore(true);
                setLoading(true);

                // console.log(res.data);
            }).catch(error => {
                console.log(error);
            });
    }, [logged_user])

    const loadMore = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/playlist.php`, {
                user_id: logged_user,
                play_id: id,
                page: page,
                action: 'GET_ALBUM_VIDEOS'
            }, {
                headers: {
                    "Content-Type": "multipart/form-data"
                    }
            }).then(res => {
                if(res.data.message !== 'No videos found') {
                    loading && hasMore && setVideos([...videos, ...res.data]);
                    res.data.length < 10 ? sethasMore(false) : sethasMore(true);
                    setpage(page + 1);
                }
            }).catch(error => {
                console.log(error);
            });
    }

    const handleDelete = (video_id) => {
        const video = document.getElementById(`video_${video_id}`);
        if(video) {
            if(window.confirm("Are you sure you want to remove this video?")) {
                const toast_id = toast.loading("Please wait...");
                axios.post(`${process.env.REACT_APP_API_URL}/api/user/playlist.php`,
                    {
                        user_id: logged_user,
                        play_id: id,
                        video_id: video_id,
                        action: 'DELETE_VIDEO'
                    }, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    }
                ).then(res => {
                    // console.log(res.data);
                    video.remove();
                    toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});
                }).catch(err => {
                    console.log(err);
                })
            }
        }
    }

    const toggleCheckAll = () => {
        const checkboxes = document.querySelectorAll('#checkrow');
        const checkall = document.querySelector('#check-all');

        if(checkall.checked) {
            checkboxes.forEach((cb) => {
                cb.checked = true;
            });
        }else {
            checkboxes.forEach((cb) => {
                cb.checked = false;
            });
        }
    }

    const deleteAll = () => {
        if(window.confirm("Are you sure you want to delete all selected video?")) {
            const toast_id = toast.loading("Please wait...");
            let data = new FormData();
            data.append('user_id', logged_user);
            var array = [];

            var checkboxes = document.querySelectorAll('#checkrow');
            for (var i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked){
                    data.append('playlistData[]', checkboxes[i].value)
                    array.push(checkboxes[i].value);
                }
            }

            axios.post(`${process.env.REACT_APP_API_URL}/api/user/playlist.php`, data , {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }).then(res => {
                    // console.log(res.data);
                    if(res.data.status === 'success') {
                        array.forEach(item => {document.getElementById(`video_${item}`).remove();});
                        toast.update(toast_id, {render: "Videos deleted successfully.", autoClose: 5000, type: "success", isLoading: false});
                    }else {
                        toast.update(toast_id, {render: "Something went wrong!", autoClose: 5000, type: "error", isLoading: false});
                    }
                }).catch(err => {
                    console.log(err);
                });
        }
    }
    
  return (
    <>
        <Helmet>
            <title>Manage Playlist</title>
        </Helmet>
        <div className="container_wrapper">
            <Header />
            <div className={`${styles.main} main`}>
                <ToastContainer />
                <Sidebar />
                <div className={styles.main_content}>
                    <div className={styles.content_body}>
                        {/* <div className={`${styles.title} mb-4 d-flex justify-content-between`}>
                            <h5><i className="fa-solid fa-film"></i> My Albums</h5>
                            <Link className="add_album_btn" to="/dashboard/add-album">
                                <button className="btn btn-secondary">Add Album</button>
                            </Link>
                        </div> */}
                        <div className={styles.card}>
                            <div className={`${styles.item_in_list} ${styles.list_header}`}>
                                <div className="checkbox">
                                    <input type="checkbox" name="checkRows" id="check-all" onClick={() => toggleCheckAll()} />
                                    <label></label> Select all
                                </div>
                                <div className={styles.delete_btn}>
                                    <button className="btn btn-danger" type="submit" onClick={() => deleteAll()}>
                                        <i className="fa-regular fa-trash-can"></i> Selected
                                    </button>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className={styles.content_items}>
                                    {
                                        videos && videos.map ?  <InfiniteScroll
                                            pageStart={0}
                                            loadMore={loadMore}
                                            hasMore={hasMore}
                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                            className='row'
                                        >
                                            {
                                                videos.map((video, index) => {
                                                    return (
                                                        <div id={`video_${video.id}`} className={styles.item_in_list} key={index}>
                                                            <div className={styles.segment}>
                                                                <div className={styles.checkbox}>
                                                                    <input id="checkrow" type="checkbox" name="playlistData[]" defaultValue={video.id} />
                                                                    <label></label>
                                                                </div>
                                                            </div>
                                                            <div className={styles.segment}>
                                                                <div className={styles.left}>
                                                                    <Link className="" target="_blank" rel="noreferrer" to={false} title="View">
                                                                        <img src={video.thumb} onError={e => {e.target.src = noThumb}} alt={video.title} />
                                                                    </Link>
                                                                </div>
                                                                <div className={styles.right}>
                                                                    <Link className={styles.content_title} target="_blank" rel="noreferrer" to={false} title="View">
                                                                        <strong><Markup content={video.title} /></strong>
                                                                    </Link>
                                                                    <div className={`${styles.btn_group} btn-group`}>
                                                                        <Link className="btn btn-danger" to={false} title="Unpublish" onClick={() => handleDelete(video.id)}>
                                                                            <i className="fa-regular fa-trash-can"></i>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </InfiniteScroll>
                                        : <EmptyContent />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                <Footer />
                </div>
            </div>
        </div>
    </>
  );
}

export default ManagePlaylist;